<template>
  <div class="home">
    <SiteHeader :with-search="false"/>
    <main>
      <HeroHome/>
      <div class="business-banner">
        <a href="https://business.ranker.com/" target="_blank">
          Visit <span class="underline">business.ranker.com</span> to learn more about <strong>Ranker’s data products</strong>
        </a>
      </div>
      <section class="content flex justify-center">
        <div class="galleries w-full">
          <h3 class="gallery-heading">Not sure where to start? Check out these examples below</h3>
          <NodeGallery v-if="recentSearches.length" :nodes="recentSearches">Recent Searches</NodeGallery>
          <NodeGallery :nodes="tv">TV</NodeGallery>
          <NodeGallery :nodes="film">Film</NodeGallery>
          <NodeGallery :nodes="people">People</NodeGallery>
        </div>
      </section>
      <BlogPostGallery :posts="blogPosts"/>
    </main>
    <SiteFooter/>
  </div>
</template>

<script>
import SiteHeader from '@/components/layout/SiteHeader';
import HeroHome from '@/components/Home/HeroHome';
import SiteFooter from '@/components/layout/SiteFooter';
import NodeGallery from '@/components/Home/NodeGallery';
import {getBlogPosts} from '@/api/blogPosts.js';
import {getHomeNodes} from '@/api/nodes.js';
import BlogPostGallery from '@/components/Home/BlogPostGallery';

export default {
  name: 'HomePage',
  components: {
    BlogPostGallery,
    NodeGallery,
    HeroHome,
    SiteHeader,
    SiteFooter
  },
  data() {
    return {
      blogPosts: [],
      tv: [],
      film: [],
      people: [],
      recentSearches: []
    };
  },
  async created() {
    (async () => {
      const result = await getBlogPosts({limit: 8});
      if (result && result.result && result.result.items) {
        this.blogPosts = result.result.items;
      }
    })();
    const nodes = await getHomeNodes() || null;
    if (nodes) {
      this.tv = nodes.tv;
      this.film = nodes.film;
      this.people = nodes.people;
      this.recentSearches = nodes.recentSearches;
    }
  }
};
</script>

<style lang="postcss">
html, body {
  scroll-behavior: smooth;
  scrollbar-width: thin;

  ::-webkit-scrollbar {
    width: 10px;
    height: 10px;
  }

  ::-webkit-scrollbar-track {
    -webkit-box-shadow: inset 0 0 6px rgba(144, 144, 144, .1);
    border-radius: 10px;
  }

  ::-webkit-scrollbar-thumb {
    border-radius: 10px;
    background-color: rgba(0, 0, 0, .1);
  }
}

.home {
  h3.gallery-heading {
    width: 100%;
    justify-content: center;
    margin-top: 50px;
    margin-bottom: 50px;
    font-family: Roboto, sans-serif;
    font-style: normal;
    font-weight: normal;
    font-size: 25px;
    line-height: 29px;
    display: flex;
    align-items: center;
    text-align: center;

    color: #000000;

    opacity: 0.85;
  }

  .galleries {
    max-width: 1440px;
    @apply flex flex-col items-center justify-center;
  }

  .business-banner {
    @apply flex items-center justify-center w-full;
    height: 60px;
    background-color: #182967;

    a {
      font-family: Roboto, sans-serif;
      font-style: normal;
      font-weight: normal;
      font-size: 18px;
      line-height: 21px;
      color: #FFFFFF;
      text-decoration: none;

      &:hover {
        opacity: 0.8;
      }

      .underline {
        text-decoration: underline;
      }

      strong {
        font-weight: bold;
      }
    }
  }
}
</style>